export const ADD_LIST_MENU = 'ADD_LIST_MENU';
export const ADD_MENU = 'ADD_MENU';
export const UPDATE_MENU = 'UPDATE_MENU';